<template>
  <div class="form">
    <div v-if="alertMessage != null" class="alert alert-danger" role="alert">
      {{ alertMessage }}
    </div>
    <label>
      <strong>Nachrichten</strong>
    </label>
    <ul class="list-group pb-3">
      <li class="list-group-item mb-0">
        <toggle-switch
          label="Sound"
          type="success list-group-item"
          v-model="newMessageSound"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0">
        <toggle-switch
          label="E-Mail"
          type="success"
          v-model="newMessageMail"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0">
        <toggle-switch
          label="Push-Mitteilung"
          type="success"
          v-model="newMessagePushNotification"
        ></toggle-switch>
      </li>
      <li v-if="telegram" class="list-group-item mb-0">
        <toggle-switch
          label="Telegram"
          type="success"
          v-model="newMessageTelegram"
        ></toggle-switch>
      </li>
    </ul>
    <hr />
    <label>
      <strong>Partnervorschlag</strong>
    </label>
    <ul class="list-group pb-3">
      <li class="list-group-item mb-0">
        <toggle-switch
          label="E-Mail"
          type="success"
          v-model="partnerProposalMail"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0">
        <toggle-switch
          label="Push-Mitteilung"
          type="success"
          v-model="partnerProposalPushNotification"
        ></toggle-switch>
      </li>
    </ul>
    <hr />
    <label>
      <strong>Gutschriften für "{{ currency }}"</strong>
    </label>
    <ul class="list-group pb-3">
      <li class="list-group-item mb-0">
        <toggle-switch label="Sound" type="success" v-model="flirtDollarSound">
        </toggle-switch>
      </li>
      <li class="list-group-item mb-0">
        <toggle-switch
          label="E-Mail"
          type="success"
          v-model="flirtDollarMail"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0">
        <toggle-switch
          label="Push-Mitteilung"
          type="success"
          v-model="flirtDollarPushNotification"
        ></toggle-switch>
      </li>
      <li v-if="telegram" class="list-group-item mb-0">
        <toggle-switch
          label="Telegram"
          type="success"
          v-model="flirtDollarTelegram"
        ></toggle-switch>
      </li>
    </ul>
    <hr />
    <label>
      <strong>Profilbesuche</strong>
    </label>
    <ul class="list-group pb-3">
      <li class="list-group-item mb-0">
        <toggle-switch
          label="Sound"
          type="success"
          v-model="profileVisitSound"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0">
        <toggle-switch
          label="Push-Mitteilung"
          type="success"
          v-model="profileVisitPushNotification"
        ></toggle-switch>
      </li>
      <li v-if="telegram" class="list-group-item mb-0">
        <toggle-switch
          label="Telegram"
          type="success"
          v-model="profileVisitTelegram"
        ></toggle-switch>
      </li>
    </ul>
    <hr />
    <label>
      <strong>Sonstiges</strong>
    </label>
    <ul class="list-group pb-3">
      <li class="list-group-item mb-0">
        <toggle-switch
          label="Newsletter"
          type="success"
          v-model="newsLetter"
        ></toggle-switch>
      </li>
    </ul>
    <v-button
      :working="working"
      type="submit"
      class="btn btn-primary float-right"
      @click.native="persist()"
      >Änderung akzeptieren</v-button
    >
  </div>
</template>

<script>
import { subscribe } from "@/pushNotification";
export default {
  props: ["is-admin", "user", "telegram-token"],
  data() {
    return {
      newMessageMail: true,
      newMessagePushNotification: true,
      newMessageSound: false,
      newMessageTelegram: false,
      partnerProposalMail: true,
      partnerProposalPushNotification: true,
      flirtDollarMail: true,
      flirtDollarPushNotification: true,
      flirtDollarSound: true,
      flirtDollarTelegram: false,
      profileVisitSound: true,
      profileVisitPushNotification: true,
      profileVisitTelegram: false,
      newsLetter: true,
      privacyPostalCodeNumbers: 3,
      alertMessage: null,
      working: false,
      settings: {}
    };
  },
  created() {
    if (Laravel.user.customer_profile) {
      this.$store.dispatch("customerProfile/read", [
        {
          name: "where",
          attributes: {
            id: [Number(Laravel.user.customer_profile.id)]
          }
        }
      ]);
    }
    Object.keys(this.computedSettings).forEach(key => {
      this.$data[key] = this.computedSettings[key];
    });
  },
  methods: {
    persist() {
      this.working = true;
      Object.keys(this.computedSettings).forEach(key => {
        this.settings[key] = this.$data[key];
      });
      this.$store
        .dispatch("userSetting/update", {
          data: {
            user_id: this.computedUser.id,
            key: this.settings
          },
          url: "/api/v1/userSetting"
        })
        .then(() => {
          this.$notify({
            title: "Die Einstellungen wurden gespeichert",
            type: "success"
          });
          this.working = false;
        });
    }
  },
  computed: {
    computedSettings() {
      return this.isAdmin ? this.user.settings : Laravel.user.settings;
    },
    computedUser() {
      return this.isAdmin ? this.user : Laravel.user;
    },
    currency() {
      return Laravel.lang.currency;
    },
    telegram() {
      let customer = {};
      if (Laravel.user.customer_profile) {
        customer = this.$store.getters["customerProfile/find"](
          Laravel.user.customer_profile.id
        );
      }
      let customerToken = customer ? customer.telegram_token : null;
      let token = this.telegramToken || customerToken;
      return Laravel.settings.messengers.telegram.active && token;
    }
  },
  watch: {
    newMessagePushNotification() {
      if (this.newMessagePushNotification) {
        if (this.isAdmin) {
          this.alertMessage =
            "Du kannst keine PushNotification für Benutzer aktivieren, weil der Browser des Nutzers die Erlaubnis benötigt!";
        } else {
          subscribe();
        }
      }
    }
  }
};
</script>
